import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { HeadingComponent } from '@sirius/common';

@Component({
    selector: 'ur-highlight',
    imports: [HeadingComponent],
    template: `
        @if (title) {
            <sirius-heading
                textStyleCategory="title"
                textStyleSize="m"
                [text]="title"
                data-cy="highlight-title"></sirius-heading>
        }
        <ng-content></ng-content>
    `,
    styleUrl: './highlight.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.aria-label]': 'title || null',
        '[attr.role]': "title ? 'region' : null",
        '[attr.data-cy]': '"highlight"',
    },
})
export class HighlightComponent {
    @Input() title?: string;
}
